module.exports = __webpack_public_path__ + "static/media/podcast-head-icon.06852723.svg";